<template>
  <div>
    <div class="refresh">下载记录<el-button type="primary" @click="handleQuery" size="mini" icon="el-icon-refresh-right">刷新</el-button></div>
    <el-table v-loading="listLoading" :data="list">
      <el-table-column label="文件名称" prop="title" align="center" />
      <el-table-column label="状态" prop="speed" align="center">
        <template slot-scope="{row}">
          <span v-if="row.state === 2">
            导出失败
            <el-tooltip v-if="row.errorLog" :content="row.errorLog" placement="top">
              <i class="el-icon-question" style="color: #f56c6c; margin-left: 5px; cursor: pointer;"></i>
            </el-tooltip>
          </span>
          <el-progress v-else :percentage="row.speed" :text-inside="true" :stroke-width="15"></el-progress>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="createdTime" align="center" />
      <el-table-column label="导出人" prop="operatedName" align="center" />
      <el-table-column label="操作" align="center">
        <template slot-scope="{row}">
          <el-button type="text" @click="handleFileDownload(row)" v-if="row.speed === 100 && row.state === 1">下载</el-button>
          <el-button type="text" @click="showErrorLog(row)" v-else-if="row.state === 2">导出失败</el-button>
          <el-button type="text" v-else>生成中</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
  </div>
</template>

<script>
import sysTaskApi from '@/api/sys/sysTask'
import Pagination from '@/components/Pagination'

/**
 * 大区导出的下载记录列表
 * 两个页签（客户信息 / 参会人员）只有任务编码不同，其余完全一致，所以抽成公共组件
 */
export default {
  components: {
    Pagination
  },
  props: {
    // 任务编码，与后端 sys_task.code 保持一致
    taskCode: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10
      }
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 查询下载记录，后端按登录人隔离
     */
    doQueryList({ pageNo, pageSize } = {}) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.listLoading = true
      return sysTaskApi.fetchList({
        pageNo: this.query.pageNo,
        pageSize: this.query.pageSize,
        codes: [this.taskCode],
        createdTimeSortSign: -1
      }).then(data => {
        this.list = data.data.list
        this.total = data.data.total
      }).finally(() => {
        this.listLoading = false
      })
    },
    async handleFileDownload(row) {
      if (!row.taskResponse) return
      try {
        const { fileUrl, fileName } = JSON.parse(row.taskResponse)
        const marketingTask = ['eeformarketingcustomer', 'eeformarketingmeetsignup'].includes((row.code || this.taskCode).trim().toLowerCase())
        let blob
        if (marketingTask) {
          const response = await sysTaskApi.downloadMarketingExport(row.id)
          blob = response.data
          if (blob.type.includes('json')) {
            const error = JSON.parse(await blob.text())
            throw new Error(error.errorMessage || error.message || '当前账号无权下载该文件，请刷新记录')
          }
        } else {
          const response = await fetch(fileUrl)
          if (!response.ok) throw new Error('文件下载失败，请刷新记录后重试')
          blob = await response.blob()
        }
        const link = document.createElement('a')
        const url = URL.createObjectURL(blob)
        link.href = url
        link.setAttribute('download', fileName)
        link.click()
        setTimeout(() => URL.revokeObjectURL(url), 1000)
      } catch (error) {
        this.$message.error(error.message || '文件下载失败，请刷新记录后重试')
      }
    },
    showErrorLog(row) {
      if (row.errorLog) {
        this.$alert(row.errorLog, '导出失败原因', {
          confirmButtonText: '确定',
          type: 'error'
        })
      } else {
        this.$message.error('导出失败，暂无详细错误信息')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './export-common.scss';
</style>
